import { createRequest } from "helpers/tools";

export const getLeadLinkedinURL = async () => {
    return await createRequest({
        suffix: `lead/lnkdn/auth-url`,
        handleError: true,
        method: "get",
    });
};

export const postLeadAuthenticateLinkedin = async (payload) => {
    return await createRequest({
        suffix: `lead/lnkdn/authenticate`,
        handleError: true,
        method: "post",
        payload,
    });
};
export const postLeadLoadFormsLinkedin = async (payload) => {
    return await createRequest({
        suffix: `lead/lnkdn/load-forms`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const postLeadRefreshLinkedin = async (payload) => {
    return await createRequest({
        suffix: `lead/lnkdn/refresh`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const getSignalLinkedinURL = async () => {
    return await createRequest({
        suffix: `destinations/linkedin/auth-url`,
        handleError: true,
        method: "get",
    });
};

export const postSignalAuthenticateLinkedin = async (payload) => {
    return await createRequest({
        suffix: `destinations/linkedin/authorize`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const postSaveLinkedinSignal = async (payload) => {
    return await createRequest({
        suffix: `destinations/linkedin/save`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const getLinkedinSignalConversions = async (destinationId) => {
    return await createRequest({
        suffix: `destinations/linkedin/${destinationId}/conversions`,
        handleError: true,
        method: "get",
    });
};

export const getLinkedinSignalMappings = async (destinationId) => {
    return await createRequest({
        suffix: `destinations/linkedin/${destinationId}/mappings`,
        handleError: true,
        method: "get",
    });
};

export const postLinkedinSignalMappings = async (destinationId, payload) => {
    return await createRequest({
        suffix: `destinations/linkedin/${destinationId}/mappings`,
        handleError: true,
        method: "post",
        payload,
    });
};
